var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn-std btn",attrs:{"href":"javascript:;","data-toggle":"modal","data-target":"#book-place"},on:{"click":_vm.saveCourseID}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }